import styled, { css } from 'styled-components';

interface IContainerProps {
  isClicked: boolean;
}

const Container = styled.div<IContainerProps>`
  position: relative;
  top: -20px;
  left: -20px;
  cursor: pointer;

  svg {
    ${({ isClicked }) => isClicked && css`
      transform: rotate(180deg);
    `}
  }
`;

interface IProps {
  isClicked: boolean;
  onClick: () => void;
}

export const SmallArrow = ({ isClicked, onClick }: IProps) => {
  return (
    <Container as='div' isClicked={isClicked} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill={isClicked ? '#00C0F3' : "black"} fillOpacity="0.56" />
      </svg>
    </Container>
  );
};
